//https://docs.mapbox.com/mapbox-gl-js/example/drag-a-point/
// https://github.com/mapbox/mapbox-gl-language/blob/master/index.js

class MaplibreTextStampControl {
    constructor() {
        this._interactiveLayer = "stampCircle";
        this._sourceName = "stamps";
        this.counter = 1;
        this._initLayers = this._initLayers.bind(this);
        this._mouseMove = this._mouseMove.bind(this);

        this.data = {
            type: "FeatureCollection",
            features: []
        };
    }

    _initLayers() {
        this._map.addSource(this._sourceName, {
            type: "geojson",
            data: this.data
        });

        this._map.addLayer({
            id: "stampCircle",
            type: "circle",
            source: this._sourceName,
            paint: {
                "circle-radius": 50,
                "circle-color": "#ffffff",
                "circle-stroke-color": "#000",
                "circle-stroke-width": 2,
                "circle-opacity": 0,
                "circle-pitch-alignment": "map"
            }
        });

        this._map.addLayer({
            id: "stampText",
            type: "symbol",
            source: this._sourceName,
            layout: {
                "text-field": "{text}",
                "text-size": 50,
                "text-rotation-alignment": "map"
            },
            paint: {
                "text-halo-color": "#ffffff",
                "text-halo-width": 1,
                "text-halo-blur": 1
            }
        });
    }

    _initHandlers() {
        this._map.on("dblclick", this._interactiveLayer, this._dblClick.bind(this));
        this._map.on("mousedown", this._interactiveLayer, this._mouseDown.bind(this));
    }

    onAdd(map) {
        this._map = map;
        this._canvas = this._map.getCanvasContainer();
        this._initLayers();
        this._initHandlers();
        // this._map.on("style.load", () => {
        // this._initLayers();
        // this._initHandlers();
        // });
        this._container = document.createElement("div");
        return this._container;
    }

    onRemove() {
        // this._map.off("style.load", this._init);
        this._map = undefined;
    }

    /* */
    _updateData() {
        const source = this._map.getSource(this._sourceName);
        if (source) {
            source.setData(this.data);
        }
    }

    /*  */
    _mouseDown(e) {
        e.preventDefault();

        const selectedFeatures = this._map.queryRenderedFeatures(e.point);
        if (selectedFeatures.length) {
            this.selectedFeature = selectedFeatures[0].id;
        }
        if (this.selectedFeature) {
            this._canvas.style.cursor = "grab";
            this._map.on("mousemove", this._mouseMove);
            this._map.once("mouseup", this._mouseUp.bind(this));
        }
    }

    _mouseUp(e) {
        this._map.off("mousemove", this._mouseMove);
        this.selectedFeature = null;
    }

    _mouseMove(e) {
        const coords = e.lngLat;

        this._canvas.style.cursor = "grabbing";

        const feature = this.data.features.find((item) => item.id === this.selectedFeature);
        if (feature) {
            feature.geometry.coordinates = [coords.lng, coords.lat];
            this._updateData();
        }
    }

    _dblClick(e) {
        e.preventDefault();

        const selectedFeatures = this._map.queryRenderedFeatures(e.point);
        if (selectedFeatures.length) {
            const featureIndex = this.data.features.findIndex((item) => item.id === selectedFeatures[0].id);
            if (featureIndex > -1) {
                this.data.features.splice(featureIndex, 1);
                this._updateData();
            }
        }
    }

    /* */

    addItem(text) {
        const coords = this._map.getCenter();
        this.data.features.push({
            type: "Feature",
            properties: { text },
            geometry: {
                coordinates: [coords.lng, coords.lat],
                type: "Point"
            },
            id: this.counter++
        });
        this._updateData();
    }
}

export default MaplibreTextStampControl;
